import { resolveAPIAssetURL } from '@/lib/app/assetURL';

export function resolveEventPosterURL(publicURL: string) {
  return resolveAPIAssetURL(publicURL, '/seed-posters/');
}
